import { get } from 'lodash';
import * as React from 'react';
import { connect } from 'react-redux';
import { AirportContribution } from '../../../../components/widgets/airport/general-data/airport-contribution/airport-contribution';
import { connectNLP } from '../../../../utilities/connect-navigate';
import { Contributions } from './contributions';

const mapStateProps = (store: any) => ({
	user: store.user.user,
});

const mapDispatchProps = (dispatch: any) => ({});

class AirportContributionsComponent extends Contributions<any, any> {
	public endpoint(): any {
		const user = get(this.props, 'user');
		const userRoles = get(user, 'roles');
		const isAdmin = userRoles.includes('ADMIN');
		const system = get(this.props, 'system');
		const systemInfo = system === true ? '/system' : `/users/${system}`;
		const otherInfo = isAdmin ? '' : `/users/${get(user, 'aid')}`;

		const systemAdminOrGeneral = isAdmin && system ? systemInfo : otherInfo;

		return `/airports/contributions${systemAdminOrGeneral}`;
	}

	public getModalEndpoint() {
		return `/airports/${get(this.state.item, 'entityAid')}`;
	}

	public renderModalContent(ctx): React.ReactElement {
		return (
			<AirportContribution
				item={this.state.item}
				onSuccess={() => this.handleModalSuccess()}
				original={get(ctx.state, 'response')}
				close={() => this.onModalClose()}
			/>
		);
	}
}

export const AirportContributions: any = connect(
	mapStateProps,
	mapDispatchProps,
	null,
	{ forwardRef: true }
)(connectNLP(AirportContributionsComponent));
